import { Injectable } from '@angular/core';
import { fromEvent, merge, Observable, Subject, timer } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProgresoTimeoutService {
  private _idle$: Observable<any>;
  private _timer$;
  private _timeOutMilliSeconds: number;
  private _idleSubscription;

  public expired$: Subject<boolean> = new Subject<boolean>();

  constructor() { }

  public startWatching(timeOutSeconds): Observable<boolean> {
    this._idle$ = merge(
      fromEvent(document, 'click'),
      fromEvent(document, 'mousedown'),
      fromEvent(document, 'keypress')
    );

    this._timeOutMilliSeconds = timeOutSeconds * 1000;

    this._idleSubscription = this._idle$.subscribe((res) => {
      this.resetTimer();
    });

    this.startTimer();

    return this.expired$;
  }

  private startTimer() {
    this._timer$ = timer(
      this._timeOutMilliSeconds,
      this._timeOutMilliSeconds
    ).subscribe((res) => {
      this.expired$.next(true);
    });
  }

  public resetTimer() {
    if (this._timer$) {
      this._timer$.unsubscribe();
    }

    this.startTimer();
  }

  public stopTimer() {
    if (this._timer$) {
      this._timer$.unsubscribe();
    }

    if (this._idleSubscription) {
      this._idleSubscription.unsubscribe();
    }
  }
}
